import React from 'react';
import PropTypes from 'prop-types';
import { Modal } from 'antd';
import { I18n as I } from 'react-redux-i18n';

import {
  LoaderOverlay,
  FormField,
  isFunc,
  isNullOrWhitespace,
  isObject,
  FieldInfo,
  ControlTypes,
} from 'vdlib';

const AuctionCommentsModal = ({
  cancelButton,
  comments: propComments,
  lang,
  loading,
  onHide,
  onSubmit,
  show,
  submitButton,
  title,
}) => {
  const [comments, setComments] = React.useState(propComments);

  const formContext = React.useRef({
    updateForm: (name, value) => setComments(value),
  });

  const handleSubmit = React.useCallback(() => {
    if (!isNullOrWhitespace(comments) && isFunc(onSubmit)) onSubmit(comments);
  }, [onSubmit, comments]);

  const handleHide = React.useCallback(() => {
    if (isFunc(onHide)) onHide();
  }, [onHide]);

  const buttons = React.useMemo(
    () =>
      [
        isObject(submitButton) ? (
          submitButton
        ) : (
          <button
            type="button"
            className={`btn btn-primary btn-sm float-right ml-sm ${
              loading ? 'disabled' : ''
            } `}
            disabled={loading}
            onClick={handleSubmit}
          >
            {submitButton || I.t('SAVE_INPUT')}
          </button>
        ),
        isObject(cancelButton) ? (
          cancelButton
        ) : (
          <button
            type="button"
            className={`btn btn-default btn-sm float-right ${
              loading ? 'disabled' : ''
            }`}
            disabled={loading}
            onClick={handleHide}
          >
            {cancelButton || I.t('CANCEL')}
          </button>
        ),
      ].filter(b => !!b),
    [loading, handleHide, handleSubmit, lang] //eslint-disable-line
  );

  return (
    <Modal
      footer={buttons}
      title={title || I.t('COMMENTS')}
      visible={show}
      onCancel={handleHide}
    >
      <LoaderOverlay loading={loading === true} />
      <br />
      <div className="row form-group mb0">
        <FormField
          containerClassName="col-12"
          value={comments}
          field={
            new FieldInfo(
              'comments',
              I.t('COMMENTS'),
              comments,
              null,
              formContext.current,
              ControlTypes.Textarea
            )
          }
          style={{ width: '500px' }}
        />
      </div>
    </Modal>
  );
};

AuctionCommentsModal.propTypes = {
  initialDuration: PropTypes.number,
  loading: PropTypes.bool,
  onHide: PropTypes.func.isRequired,
  onSubmit: PropTypes.func.isRequired,
  show: PropTypes.bool,
  theme: PropTypes.string,
  title: PropTypes.string,
};

export default AuctionCommentsModal;
